/**
 * Utility functions for cookie management
 */

/**
 * Sets a cookie with the given name, value, and expiration days
 * @param {string} name - Cookie name
 * @param {string} value - Cookie value
 * @param {number} days - Number of days until expiration
 */
export function setCookie(name, value, days) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/';
}

/**
 * Deletes a cookie by setting its expiration to a past date
 * @param {string} name - Cookie name to delete
 */
export function deleteCookie(name) {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
}

/**
 * Gets a cookie value by name
 * @param {string} name - Cookie name
 * @returns {string|null} Cookie value or null if not found
 */
export function getCookie(name) {
    const match = document.cookie
        .split('; ')
        .find(row => row.startsWith(name + '='));
    if (!match) return null;
    return decodeURIComponent(match.substring(name.length + 1)) || null;
}

/**
 * Checks if a token cookie exists
 * @returns {boolean} True if token cookie exists
 */
export function hasTokenCookie() {
    return document.cookie.split(';').some((item) => item.trim().startsWith('token='));
}

/**
 * Gets the token from cookies
 * @returns {string|null} Token value or null if not found
 */
export function getToken() {
    return getCookie('token');
} 